import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Contract } from "@/types/contract";

interface OriginalTermsProps {
  contract: Contract;
  formatCurrency: (value: number | null | undefined) => string;
  formatDate: (dateString: string | null | undefined) => string;
}

export function OriginalTerms({ contract, formatCurrency, formatDate }: OriginalTermsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Original Contract Terms</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <span className="font-medium">Sales Price:</span>
            <p>{formatCurrency(contract.original_sales_price)}</p>
          </div>
          <div>
            <span className="font-medium">Down Payment:</span>
            <p>{formatCurrency(contract.original_down_payment)}</p>
          </div>
          <div>
            <span className="font-medium">Interest Rate:</span>
            <p>{contract.original_interest_rate ? `${contract.original_interest_rate}%` : 'N/A'}</p>
          </div>
          <div>
            <span className="font-medium">Original Term:</span>
            <p>{contract.original_term ? `${contract.original_term} months` : 'N/A'}</p>
          </div>
          <div>
            <span className="font-medium">Monthly Payment:</span>
            <p>{formatCurrency(contract.original_monthly_payment)}</p>
          </div>
          <div>
            <span className="font-medium">Sales Date:</span>
            <p>{formatDate(contract.sales_date)}</p>
          </div>
        </div>
        
        {contract.has_balloon_payment && (
          <>
            <Separator className="my-4" />
            <div className="grid grid-cols-2 gap-4">
              <div>
                <span className="font-medium">Balloon Payment:</span>
                <p>{formatCurrency(contract.original_balloon_payment)}</p>
              </div>
              <div>
                <span className="font-medium">Balloon Due Date:</span>
                <p>{formatDate(contract.balloon_payment_due_date)}</p>
              </div>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}